import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import "assets/css/material-dashboard-react.css?v=1.5.0";

import indexRoutes from "routes/index.jsx";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import SentryErrorBoundary from "components/ErrorBoundary/SentryErrorBoundary.jsx";

import { SENTRY_DSN } from "config.js";

// import "init-firebase.js";

const hist = createBrowserHistory();

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_VERSION
  });

  window.addEventListener("error", event => {
    if (!event.error) {
      return;
    }

    Sentry.withScope(scope => {
      scope.setTag("source", "window.error");
      scope.setExtra("filename", event.filename);
      scope.setExtra("lineno", event.lineno);
      scope.setExtra("colno", event.colno);
      Sentry.captureException(event.error);
    });
  });

  window.addEventListener("unhandledrejection", event => {
    const reason = event.reason;
    const rejectionError =
      reason instanceof Error
        ? reason
        : new Error(
            typeof reason === "string"
              ? reason
              : "Unhandled promise rejection"
          );

    Sentry.withScope(scope => {
      scope.setTag("source", "window.unhandledrejection");
      if (reason && !(reason instanceof Error)) {
        scope.setExtra("reason", reason);
      }
      Sentry.captureException(rejectionError);
    });
  });
}

ReactDOM.render(
  <SentryErrorBoundary>
    <Router history={hist}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return <Route path={prop.path} component={prop.component} key={key} />;
        })}
      </Switch>
    </Router>
  </SentryErrorBoundary>,
  document.getElementById("root")
);

// Register service worker for PWA support and cache management
// eslint-disable-next-line no-console
serviceWorkerRegistration.register({
  onUpdate: registration => {
    // When an update is found, notify user or auto-reload
    // eslint-disable-next-line no-console
    console.log("New version available! Refreshing...");
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },
  onSuccess: () => {
    // eslint-disable-next-line no-console
    console.log("Service worker registered successfully");
  }
});
